// Telefon titreşimi. Mobil uygulama (yeni sürüm) yerel titreşimi destekliyorsa ona,
// değilse tarayıcının navigator.vibrate'ine gider (iOS tarayıcısında titreşim yok).
let lastVibrateAt = 0;

export function vibrateShort(minGapMs = 700) {
  const now = Date.now();
  if (now - lastVibrateAt < minGapMs) return;
  lastVibrateAt = now;
  try {
    if (window.__text2NativeHaptics && window.ReactNativeWebView?.postMessage) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'HAPTIC', kind: 'short' }));
      return;
    }
  } catch (_) {
    // yerel köprü yoksa tarayıcıya düş
  }
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') navigator.vibrate(40);
  } catch (_) {
    // titreşim desteklenmiyor
  }
}
